var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16573F18-2A1A-48F8-AC46-B9D5DA6C432A-17830-0009432B630CE32D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2 2 16 2 16 16 2 16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inventory",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inventory-view-(w-Images)",
    transform: "translate(-9.000000, -340.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-/-sidenav-/-expanded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Account",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Help",
    transform: "translate(9.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1511667,10.27225 C11.2726667,10.9360833 10.183,11.3339167 9,11.3339167 C7.81583333,11.3339167 6.72558333,10.9349167 5.84533333,10.2710833 C3.47058333,11.317 2,14.57375 2,16 L16,16 C16,14.5865833 14.4833333,11.3298333 12.1511667,10.27225 M13.0833333,6.08391667 C13.0833333,8.33908333 11.2551667,10.16725 9,10.16725 C6.74425,10.16725 4.91666667,8.33908333 4.91666667,6.08391667 C4.91666667,3.82816667 6.74425,2 9,2 C11.2551667,2 13.0833333,3.82816667 13.0833333,6.08391667",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.79a84f865f8fdab5698b6ad9122e0d7d.svg";
export { ForwardRef as ReactComponent };